var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.7035V14.25H13.5V15.75H4.5V14.25H8.25V12.7035C6.80002 12.5207 5.46661 11.8149 4.5 10.7188C3.53339 9.62267 3.00002 8.21146 3 6.75V2.25H15V6.75C15 8.21146 14.4666 9.62267 13.5 10.7188C12.5334 11.8149 11.2 12.5207 9.75 12.7035ZM4.5 3.75V6.75C4.5 7.94347 4.97411 9.08807 5.81802 9.93198C6.66193 10.7759 7.80653 11.25 9 11.25C10.1935 11.25 11.3381 10.7759 12.182 9.93198C13.0259 9.08807 13.5 7.94347 13.5 6.75V3.75H4.5ZM0.75 3.75H2.25V6.75H0.75V3.75ZM15.75 3.75H17.25V6.75H15.75V3.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyLine);
export default __webpack_public_path__ + "static/media/trophy-line.975dbaac2cf99db91d69bb437eeadb90.svg";
export { ForwardRef as ReactComponent };